import { useQuery } from '@tanstack/react-query';
import { MsApiEndPoints } from '@wolfejs/ms-api-js/src';
import { useMsClient } from '../../contexts';

/**
 * This hook is used to get the currently logged in user's details. Can also be used to check if there is an authenticated user.
 */
export function useMyAccount() {
  const { client } = useMsClient();
  const key = MsApiEndPoints.myaccount.get();
  return useQuery({
    queryKey: [key],
    queryFn: async () => (await client.myaccount.userDetails()).data,
  });
}

/**
 * This hook is used to get the currently logged in user's details. Can also be used to check if there is an authenticated user.
 */
export function useMyAccountPermissions() {
  const { client } = useMsClient();
  const key = MsApiEndPoints.myaccount.permissions();
  return useQuery({
    queryKey: [key],
    queryFn: async () => (await client.myaccount.permissions()).data,
  });
}
